<div>
    <div class="d-flex align-items-center" mat-dialog-title>
        <div class="spacer title">Materieel</div>
        <div>
            <button (click)="close()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
        </div>
    </div>
</div>

<div class="dialog-content" mat-dialog-content>
    <mat-slide-toggle class="mb-3" (change)="showFinished($event.checked)">
        Toon materieel dat uit dienst is
    </mat-slide-toggle>

    <button class="ml-3" [disabled]="isSyncing()" (click)="sync()" color="primary" mat-raised-button>
        @if (isSyncing()) {
            <i class="fas fa-spinner fa-spin"></i>
        }
        Synchroniseren met AFAS
    </button>

    @for (entityGroup of entities; track entityGroup) {
        <div>
            <div class="d-flex justify-content-center align-content-center">
                <h3 class="spacer">
                    {{ entityGroup.type.plural_name }}
                </h3>
            </div>
            <div class="pl-4">
                <table
                    class="table table-hover"
                    [class.table-add-row]="!entityGroup.type.afas_name"
                    (cdkDropListDropped)="drop($event, entityGroup)"
                    cdkDropList>
                    <tr>
                        <th>Naam</th>
                        <th width="160">Excl. transporttijd</th>
                        <th width="160">Standaard start- stop</th>
                        @if (entityGroup.type.has_driver) {
                            <th>Voorkeurschauffeur</th>
                        }
                        @if (entityGroup.type.has_lowloader) {
                            <th>Dieplader</th>
                        }
                        @if (entityGroup.type.has_preferred_team) {
                            <th>Voorkeursploeg</th>
                        }
                        @if (entityGroup.type.has_truck) {
                            <th>Trekkend voertuig</th>
                        }
                        <th>Begindatum</th>
                        <th>Einddatum</th>
                    </tr>
                    @for (entity of entityGroup.entities; track entity) {
                        <tr class="curpoint" (click)="openEntity(entity)" cdkDrag>
                            <td class="drag">
                                <div class="drag-handle" cdkDragHandle>
                                    <i class="fa fa-th-list"></i>
                                </div>
                                {{ entity.name }}
                            </td>
                            <td class="text-center">
                                @if (entity.exclude_driving_hours) {
                                    <i class="fa fa-check"></i>
                                }
                            </td>
                            <td class="text-center">
                                @if (entity.default_transport_none) {
                                    <i class="fa-duotone fa-xmark"></i>
                                }
                                @if (entity.default_transport_home) {
                                    <i class="fa-duotone fa-house-user"></i>
                                }
                            </td>
                            @if (entityGroup.type.has_driver) {
                                <td>
                                    {{ (users | byId: entity.driver_user_id)?.name }}
                                </td>
                            }
                            @if (entityGroup.type.has_lowloader) {
                                <td>
                                    {{ (allEntities | byId: entity.lowloader_entity_id)?.name }}
                                </td>
                            }
                            @if (entityGroup.type.has_preferred_team) {
                                <td>
                                    {{ (allEntities | byId: entity.team_entity_id)?.name }}
                                </td>
                            }
                            @if (entityGroup.type.has_truck) {
                                <td>
                                    {{ (allEntities | byId: entity.truck_entity_id)?.name }}
                                </td>
                            }
                            <td class="datetime">
                                {{ entity.begindate | date: 'd MMMM yyyy' }}
                            </td>
                            <td class="datetime">
                                {{ entity.enddate | date: 'd MMMM yyyy' }}
                            </td>
                        </tr>
                    }
                    @if (!entityGroup.type.afas_name) {
                        <tr>
                            <td [attr.colspan]="5 + (extraColsMap.get(entityGroup.type.key) ?? 0)">
                                <button class="w-100" (click)="addEntity(entityGroup.type)" color="primary" mat-button>
                                    {{ entityGroup.type.name }} toevoegen <i class="fas fa-plus"></i>
                                </button>
                            </td>
                        </tr>
                    }
                </table>
            </div>
        </div>
    }
</div>
